import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'antd';
import { DragableTableFrom } from '@components';
import { Button, PopAlert } from 'appkit-react';

import { columns } from './configs/columns.config';
import { FORM_KEYS } from './configs/form.keys';
import actions from '@flux/action';
import { useDispatch } from 'react-redux';

const WRAPPER_KEY = FORM_KEYS.TABLE_WRAPPER.key;

function OperatingModelEdit({
  setIsEditMode,
  operatingModel: data,
  projectId,
}) {
  const [formData, setFormData] = useState(
    data.map((e, index) => ({
      ...e,
      name: {
        text: e.name,
        id: e.id,
      },
      activities: {
        data: e.activities.map((i) => i.description),
        id: e.id,
      },
    })),
  );
  const [actionLoading, toggleActionLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const fieldMethods = useRef({});

  const registerFieldsMethods = (methods) => {
    fieldMethods.current = methods;
  };
  const handleSortEnd = ({ newIndex, oldIndex }) => {
    const { move } = fieldMethods.current;

    if (move) {
      move(oldIndex, newIndex);
    }
  };
  const handleSubmitForm = () => {
    form.validateFields().then(handleSave);
  };
  const handleSave = async (newFormData) => {
    toggleActionLoading(true);
    const updatedData = newFormData.operatingModelList.map((e) => ({
      name: e.name.text,
      activities: e.activities.data.map((i) => ({
        description: i,
      })),
    }));
    const saveResult = await dispatch(
      actions.updateOperatingModel(
        {
          operatingModelInfo: updatedData,
        },
        projectId,
      ),
    );
    if (saveResult?.success) {
      goBack();
      PopAlert({
        className: 'success-message-popover',
        oneLineDisplay: true,
        duration: 2000,
        status: 'success',
        message: 'SAVED SUCCESSFULLY',
      });
    }
  };
  const goBack = () => {
    setIsEditMode(false);
  };
  useEffect(() => {
    const formData = data.map((e, index) => ({
      ...e,
      name: {
        text: e.name,
        id: e.id,
      },
      activities: {
        data: e.activities.map((i) => i.description),
        id: e.id,
      },
    }));
    setFormData(formData);
    form.setFieldsValue({ [WRAPPER_KEY]: formData });
  }, [data]);

  return (
    <div className="insights-operating-model-edit">
      <span className="dd-back-btn" onClick={goBack}>
        <span className="appkiticon icon-left-chevron-fill a-font-12" />
        Back
      </span>
      <div className="title">Manage Operating Model</div>
      <div className="manage-module-wrapper operating-model-edit-wrapper">
        <Form
          form={form}
          scrollToFirstError
          autoComplete="off"
          className="integration-manage-form"
        >
          <div className="dragable-table-form">
            <DragableTableFrom
              formData={formData}
              registerFieldsMethods={registerFieldsMethods}
              onSortEnd={handleSortEnd}
              isActive
              formInstance={form}
              columns={columns}
              name={WRAPPER_KEY}
              isLoading={false}
              addBtnText="Add New Operating Model"
            />
          </div>

          <div className="action-wrapper">
            <Button
              size="xl"
              kind="secondary"
              onClick={goBack}
              isLoading={actionLoading}
            >
              Cancel
            </Button>
            <Button
              size="xl"
              onClick={handleSubmitForm}
              isLoading={actionLoading}
            >
              Save
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default OperatingModelEdit;
